import { render, staticRenderFns } from "./bowser.vue?vue&type=template&id=16a4cf20&scoped=true"
import script from "./bowser.vue?vue&type=script&lang=ts"
export * from "./bowser.vue?vue&type=script&lang=ts"
import style0 from "./bowser.vue?vue&type=style&index=0&id=16a4cf20&prod&lang=less"
import style1 from "./bowser.vue?vue&type=style&index=1&id=16a4cf20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a4cf20",
  null
  
)

export default component.exports